/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState, useRef, useMemo } from "react";
import { getAllYears, formatAmount } from "../../../../services/appService";
import { calculateIndex, paginate } from "../../../../utlis/paginate";
import PageSizeOptions from "../../../../components/PageSizeOptions";
import AddComplaince from "../../../../components/AddComplaince";
import WorkflowMapPopup from "../../../../components/WorkflowMapPopup";
import Pagination from "../../../../comman/pagination";
import Moment from "react-moment";
import { useDispatch, useSelector } from "react-redux";
import { getTenNintyComplianceReports, loadTenNintyComplianceReports } from "../../../store/complianceReports";
import useDocDownload from "../../../hooks/useDocDownload";

const Ten99CandidateComp = () => {

    const years = getAllYears();

    const [year, setYear] = useState("");
    const [complianceReport, setComplianceReport] = useState([]);
    const [showHideCompliance, setShowHideCompliance] = useState(false);
    const [selectedObj, setSelectedObj] = useState(null);

    const [workflowShowHide, setWorkflowShowHide] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(5);
    const [startIndex, setStartIndex] = useState(0);
    const [endIndex, setEndIndex] = useState(5);

    // Live search, loading, and scroll states
    const [tableSearchTerm, setTableSearchTerm] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [hasFetched, setHasFetched] = useState(false);
    const [tableWidth, setTableWidth] = useState(0);

    const topScrollRef = useRef(null);
    const tableWrapperRef = useRef(null);

    const tenNintyCandidateComplianceReportsSelector = useSelector(getTenNintyComplianceReports);
    const [handleDownloadFile] = useDocDownload();
    const dispatch = useDispatch();

    useEffect(() => {
        setComplianceReport(tenNintyCandidateComplianceReportsSelector);
    }, [tenNintyCandidateComplianceReportsSelector]);

    const handle1099CandidateCompliance = async () => {
        if (!year || isLoading) return;

        setIsLoading(true);
        setHasFetched(true);
        setTableSearchTerm("");

        try {
            await dispatch(loadTenNintyComplianceReports(year));
        } catch (error) {
            console.error("Failed to load 1099 compliance reports:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleYearChange = (val) => {
        setYear(val);
        setComplianceReport([]);
        setHasFetched(false);
        setTableSearchTerm("");
    };

    const handleShowHideCompliance = (type, obj) => {
        if (obj === "save") {
            setShowHideCompliance(false);
            setSelectedObj(null);
            if (year > 0)
                dispatch(loadTenNintyComplianceReports(year));
        } else {
            setShowHideCompliance(!showHideCompliance);
            setSelectedObj(obj);
        }
    };

    const handlePageSizeChanged = ({ currentTarget }) => {
        setPageSize(parseInt(currentTarget.value, 10));
        setCurrentPage(1);
        setStartIndex(0);
        setEndIndex(5);
    };

    const handlePageChange = (page) => {
        const { startIndex: start, endIndex: end } = calculateIndex(page, startIndex, endIndex);
        setCurrentPage(page);
        setStartIndex(start);
        setEndIndex(end);
    };

    // Declarative filtering based on search query
    const filteredReports = useMemo(() => {
        if (!complianceReport) return [];
        return complianceReport.filter(item => {
            const term = tableSearchTerm.toLowerCase();
            const fullName = `${item.name || ""} ${item.lastName || ""}`.toLowerCase();
            const matchesSearch = term === "" ||
                fullName.includes(term) ||
                String(item.id || "").toLowerCase().includes(term);
            return matchesSearch;
        });
    }, [complianceReport, tableSearchTerm]);

    // KPI Metrics calculation
    const total1099Candidates = filteredReports.length;
    const totalInvoiced = useMemo(() => {
        return filteredReports.reduce((sum, item) => sum + (parseFloat(item.totalInvoiceAmount) || 0), 0);
    }, [filteredReports]);

    const totalPaid = useMemo(() => {
        return filteredReports.reduce((sum, item) => sum + (parseFloat(item.totalPaidAmount) || 0), 0);
    }, [filteredReports]);

    const totalDue = useMemo(() => {
        return filteredReports.reduce((sum, item) => sum + (parseFloat(item.totalDueAmount) || 0), 0);
    }, [filteredReports]);

    const getPagedData = () => {
        const total = filteredReports.length;
        const filterData = paginate(filteredReports, currentPage, pageSize);
        return { totalCount: total, data: filterData };
    };

    const { data: tenNintyCompliance } = getPagedData();

    const handleWorkflowModalShowHide = () => {
        setWorkflowShowHide(!workflowShowHide);
    };

    // Scroll synchronization
    const handleTopScroll = () => {
        if (topScrollRef.current && tableWrapperRef.current) {
            tableWrapperRef.current.scrollLeft = topScrollRef.current.scrollLeft;
        }
    };

    const handleTableScroll = () => {
        if (topScrollRef.current && tableWrapperRef.current) {
            topScrollRef.current.scrollLeft = tableWrapperRef.current.scrollLeft;
        }
    };

    useEffect(() => {
        const updateWidth = () => {
            const table = document.getElementById("ten99_compliance_table");
            if (table) {
                setTableWidth(table.scrollWidth);
            }
        };

        updateWidth();
        const timer = setTimeout(updateWidth, 500);

        window.addEventListener("resize", updateWidth);
        return () => {
            window.removeEventListener("resize", updateWidth);
            clearTimeout(timer);
        };
    }, [filteredReports, year]);

    return (
        <div className="ach-pay-container animate-fade-in">
            <style>{`
                .ach-pay-container {
                    font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
                    color: #1e293b;
                    margin-bottom: 2rem;
                }

                /* KPI Metric cards */
                .ach-pay-kpi-row {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
                    gap: 16px;
                    margin-bottom: 24px;
                }

                .ach-pay-metric-card {
                    background: #ffffff;
                    border: 1px solid #e2e8f0;
                    border-radius: 12px;
                    padding: 14px 18px;
                    display: flex;
                    align-items: center;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.01);
                }

                .ach-pay-metric-icon {
                    width: 38px;
                    height: 38px;
                    border-radius: 8px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 16px;
                    margin-right: 14px;
                    background: #f1f5f9;
                    color: #475569;
                    flex-shrink: 0;
                }

                .ach-pay-metric-val {
                    font-size: 18px;
                    font-weight: 800;
                    color: #0f172a;
                    line-height: 1.1;
                    margin-bottom: 2px;
                }

                .ach-pay-metric-label {
                    font-size: 10.5px;
                    color: #64748b;
                    font-weight: 600;
                    text-transform: uppercase;
                    letter-spacing: 0.02em;
                }

                /* Controls Layout */
                .ach-pay-controls {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    gap: 12px;
                    margin-bottom: 1.5rem;
                    background-color: #fafbfc;
                    border: 1px solid #e2e8f0;
                    border-radius: 10px;
                    padding: 14px 18px;
                }

                .ach-pay-controls-group {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    flex-wrap: wrap;
                }

                .ach-pay-search-wrapper {
                    position: relative;
                    width: 240px;
                }

                .ach-pay-search-input {
                    width: 100%;
                    padding: 8px 12px 8px 34px;
                    background: #ffffff;
                    border: 1px solid #cbd5e1;
                    border-radius: 8px;
                    font-size: 12.5px;
                    color: #1e293b;
                    transition: all 0.2s ease;
                }

                .ach-pay-search-input:focus {
                    outline: none;
                    border-color: #4f46e5;
                    box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.15);
                }

                .ach-pay-search-icon {
                    position: absolute;
                    left: 12px;
                    top: 50%;
                    transform: translateY(-50%);
                    color: #94a3b8;
                    font-size: 12px;
                }

                .ach-pay-filter-select {
                    height: 35px;
                    border: 1px solid #cbd5e1;
                    border-radius: 8px;
                    padding: 0 10px;
                    font-size: 12.5px;
                    color: #475569;
                    background: #ffffff;
                    min-width: 130px;
                }

                .ach-pay-filter-select:focus {
                    outline: none;
                    border-color: #4f46e5;
                }

                .ach-pay-btn {
                    height: 35px;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    gap: 6px;
                    padding: 0 14px;
                    border-radius: 8px;
                    font-size: 12.5px;
                    font-weight: 600;
                    cursor: pointer;
                    transition: all 0.15s ease;
                    border: 1px solid #cbd5e1;
                    background: #ffffff;
                    color: #475569;
                }

                .ach-pay-btn:hover:not(:disabled) {
                    background-color: #f8fafc;
                    color: #0f172a;
                    border-color: #94a3b8;
                }

                .ach-pay-btn:disabled {
                    background-color: #f1f5f9;
                    border-color: #e2e8f0;
                    color: #94a3b8;
                    cursor: not-allowed;
                }

                .ach-pay-btn-primary {
                    background: linear-gradient(135deg, #4f46e5 0%, #4338ca 100%) !important;
                    color: #ffffff !important;
                    border: 1px solid #4338ca !important;
                    box-shadow: 0 4px 12px rgba(79, 70, 229, 0.15);
                    transition: all 0.2s ease;
                    padding: 0 16px;
                }

                .ach-pay-btn-primary:hover:not(:disabled) {
                    background: linear-gradient(135deg, #4338ca 0%, #3730a3 100%) !important;
                    border-color: #3730a3 !important;
                    box-shadow: 0 6px 16px rgba(79, 70, 229, 0.25);
                    transform: translateY(-1px);
                }

                .ach-pay-btn-primary:disabled {
                    background: #f1f5f9 !important;
                    border-color: #e2e8f0 !important;
                    color: #94a3b8 !important;
                    box-shadow: none !important;
                    cursor: not-allowed;
                }

                /* Table modifications */
                .ach-pay-table-wrapper {
                    border: 1px solid #e2e8f0;
                    border-radius: 12px;
                    overflow-x: auto;
                    overflow-y: hidden;
                    background: white;
                    box-shadow: 0 4px 12px rgba(0,0,0,0.01);
                }

                .ach-pay-table {
                    width: 100%;
                    border-collapse: collapse;
                    font-size: 13px;
                    text-align: left;
                }

                .ach-pay-table th {
                    background-color: #f8fafc;
                    color: #475569;
                    font-weight: 700;
                    text-transform: uppercase;
                    font-size: 10.5px;
                    letter-spacing: 0.05em;
                    padding: 12px 16px;
                    border-bottom: 2px solid #e2e8f0;
                    white-space: nowrap;
                }

                .ach-pay-table td {
                    padding: 12px 16px;
                    border-bottom: 1px solid #f1f5f9;
                    color: #334155;
                    transition: background-color 0.15s ease;
                    white-space: nowrap;
                }

                .ach-pay-table tr:hover td {
                    background-color: #f8fafc;
                }

                .ach-pay-table td.col-amount {
                    color: #0f172a;
                    font-weight: 600;
                    text-align: right !important;
                }

                /* Shimmer and Loading Animation */
                @keyframes shimmer {
                  0%   { background-position: -600px 0; }
                  100% { background-position: 600px 0; }
                }

                @keyframes loadingBar {
                  0%   { width: 0%; opacity: 1; }
                  70%  { width: 85%; opacity: 1; }
                  100% { width: 100%; opacity: 0; }
                }

                .wf-loading-bar {
                  position: absolute;
                  top: 0;
                  left: 0;
                  right: 0;
                  height: 3px;
                  background: linear-gradient(90deg, #4f46e5, #0ea5e9, #4f46e5);
                  background-size: 200% 100%;
                  animation: loadingBar 1.6s ease-in-out infinite;
                  z-index: 10;
                }

                .skeleton-cell {
                  display: block;
                  height: 12px;
                  border-radius: 6px;
                  background: linear-gradient(
                    90deg,
                    #f1f5f9 25%,
                    #e2e8f0 50%,
                    #f1f5f9 75%
                  );
                  background-size: 600px 100%;
                  animation: shimmer 1.4s ease-in-out infinite;
                }

                .skeleton-cell.sk-short  { width: 40%; }
                .skeleton-cell.sk-medium { width: 65%; }
                .skeleton-cell.sk-long   { width: 85%; }

                .skeleton-row td {
                  padding: 14px 16px !important;
                }

                /* Enhanced empty state */
                .wf-empty-state {
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  justify-content: center;
                  padding: 50px 24px;
                  text-align: center;
                  gap: 12px;
                }

                .wf-empty-icon {
                  width: 52px;
                  height: 52px;
                  border-radius: 14px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  font-size: 22px;
                  background: linear-gradient(135deg, rgba(79, 70, 229, 0.08) 0%, rgba(14, 165, 233, 0.06) 100%);
                  border: 1px solid rgba(79, 70, 229, 0.12);
                  color: #4f46e5;
                  margin-bottom: 4px;
                }

                .wf-empty-title {
                  font-size: 15px;
                  font-weight: 700;
                  color: #1e293b;
                  margin: 0;
                  width: 100%;
                  text-align: center;
                }

                .wf-empty-desc {
                  font-size: 13px;
                  color: #64748b;
                  margin: 0 auto;
                  line-height: 1.6;
                  text-align: center;
                  width: 100%;
                }
            `}</style>

            {/* Controls Bar */}
            <div className="ach-pay-controls">
                <div className="ach-pay-controls-group">
                    <div className="ach-pay-search-wrapper">
                        <i className="fa fa-search ach-pay-search-icon"></i>
                        <input
                            type="text"
                            placeholder="Search candidate..."
                            className="ach-pay-search-input"
                            value={tableSearchTerm}
                            onChange={(e) => setTableSearchTerm(e.target.value)}
                            disabled={complianceReport.length === 0}
                        />
                    </div>

                    <select
                        name="year"
                        id="year"
                        className="ach-pay-filter-select"
                        onChange={({ currentTarget }) => handleYearChange(currentTarget.value)}
                        value={year}
                        disabled={isLoading}
                    >
                        <option value="">Select Year</option>
                        {years.map((y) => (
                            <option key={y.name} value={y.name}>
                                {y.name}
                            </option>
                        ))}
                    </select>

                    <button
                        className="ach-pay-btn ach-pay-btn-primary"
                        disabled={!year || isLoading}
                        onClick={handle1099CandidateCompliance}
                    >
                        <i className="fa fa-refresh" style={{ fontSize: "11px", marginRight: "6px" }}></i>
                        Generate Report
                    </button>
                </div>

                <div className="ach-pay-controls-group">
                    <PageSizeOptions
                        pageSize={pageSize}
                        onChange={handlePageSizeChanged}
                    />
                </div>
            </div>

            {/* Empty and Data States */}
            {!year ? (
                <div className="wf-empty-state" style={{ border: "1px dashed #cbd5e1", borderRadius: "12px", background: "#f8fafc" }}>
                    <div className="wf-empty-icon">
                        <i className="fa fa-calendar-o"></i>
                    </div>
                    <p className="wf-empty-title">No Year Selected</p>
                    <p className="wf-empty-desc">Choose a tax year from the controls above to review compliance documents.</p>
                </div>
            ) : !hasFetched ? (
                <div className="wf-empty-state" style={{ border: "1px dashed #cbd5e1", borderRadius: "12px", background: "#f8fafc" }}>
                    <div className="wf-empty-icon">
                        <i className="fa fa-play-circle-o" style={{ color: "#4f46e5" }}></i>
                    </div>
                    <p className="wf-empty-title">Ready to Load Data</p>
                    <p className="wf-empty-desc">Click the "Generate Report" button above to fetch 1099 candidate compliance records.</p>
                </div>
            ) : (
                <div className="ach-pay-report-body p-0">
                    {/* KPI Metrics Dashboard */}
                    {filteredReports.length > 0 && (
                        <div className="ach-pay-kpi-row" style={{ marginTop: "16px" }}>
                            <div className="ach-pay-metric-card">
                                <div className="ach-pay-metric-icon" style={{ background: "rgba(99, 102, 241, 0.08)", color: "#4f46e5" }}>
                                    <i className="fa fa-user-circle-o"></i>
                                </div>
                                <div>
                                    <div className="ach-pay-metric-val">{total1099Candidates}</div>
                                    <div className="ach-pay-metric-label">1099 Candidates</div>
                                </div>
                            </div>
                            <div className="ach-pay-metric-card">
                                <div className="ach-pay-metric-icon" style={{ background: "rgba(6, 182, 212, 0.08)", color: "#06b6d4" }}>
                                    <i className="fa fa-usd"></i>
                                </div>
                                <div>
                                    <div className="ach-pay-metric-val">{"$" + formatAmount(totalInvoiced)}</div>
                                    <div className="ach-pay-metric-label">Gross Invoiced</div>
                                </div>
                            </div>
                            <div className="ach-pay-metric-card">
                                <div className="ach-pay-metric-icon" style={{ background: "rgba(16, 185, 129, 0.08)", color: "#10b981" }}>
                                    <i className="fa fa-check-circle-o"></i>
                                </div>
                                <div>
                                    <div className="ach-pay-metric-val">{"$" + formatAmount(totalPaid)}</div>
                                    <div className="ach-pay-metric-label">Total Paid</div>
                                </div>
                            </div>
                            <div className="ach-pay-metric-card">
                                <div className="ach-pay-metric-icon" style={{ background: totalDue > 0 ? "rgba(239, 68, 68, 0.08)" : "rgba(16, 185, 129, 0.08)", color: totalDue > 0 ? "#ef4444" : "#10b981" }}>
                                    <i className="fa fa-exclamation-triangle"></i>
                                </div>
                                <div>
                                    <div className="ach-pay-metric-val" style={{ color: totalDue > 0 ? "#ef4444" : "#10b981" }}>{"$" + formatAmount(totalDue)}</div>
                                    <div className="ach-pay-metric-label">Outstanding Balance</div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Synchronized top scrollbar */}
                    {filteredReports.length > 0 && (
                        <div
                            ref={topScrollRef}
                            onScroll={handleTopScroll}
                            style={{ overflowX: "auto", overflowY: "hidden", height: "14px", width: "100%", marginBottom: "4px" }}
                        >
                            <div style={{ width: `${tableWidth}px`, height: "1px" }}></div>
                        </div>
                    )}

                    {/* Table wrapper */}
                    <div
                        ref={tableWrapperRef}
                        onScroll={handleTableScroll}
                        className="ach-pay-table-wrapper"
                        style={{ position: "relative" }}
                    >
                        {isLoading && <div className="wf-loading-bar" />}

                        {isLoading ? (
                            /* SKELETON TABLE LOADING SCREEN */
                            <table className="ach-pay-table">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Candidate</th>
                                        <th className="text-right">Total Invoice Amount</th>
                                        <th className="text-right">Total Paid Amount</th>
                                        <th className="text-right">Total Balance Amount</th>
                                        <th>Upload / Document</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {[1, 2, 3, 4, 5].map((i) => (
                                        <tr key={`skel-${i}`} className="skeleton-row">
                                            <td><span className="skeleton-cell sk-short" style={{ animationDelay: `${i * 0.05}s` }} /></td>
                                            <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.07}s` }} /></td>
                                            <td><span className="skeleton-cell sk-short" style={{ animationDelay: `${i * 0.05}s` }} /></td>
                                            <td><span className="skeleton-cell sk-short" style={{ animationDelay: `${i * 0.06}s` }} /></td>
                                            <td><span className="skeleton-cell sk-short" style={{ animationDelay: `${i * 0.08}s` }} /></td>
                                            <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.05}s` }} /></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ) : filteredReports.length > 0 ? (
                            <table
                                className="ach-pay-table"
                                id="ten99_compliance_table"
                            >
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Candidate</th>
                                        <th className="text-right">Total Net Amount</th>
                                        <th className="text-right">Total Paid Amount</th>
                                        <th className="text-right">Total Balance Amount</th>
                                        <th>
                                            Upload / Compliance Docs
                                            <img
                                                src="/assets/Images/WFAssociationIcons/process.gif"
                                                className="w-auto ml-3"
                                                role="button"
                                                style={{ height: "18px", verticalAlign: "middle", transition: "transform 0.2s" }}
                                                onClick={handleWorkflowModalShowHide}
                                                onMouseOver={(e) => e.currentTarget.style.transform = "scale(1.1)"}
                                                onMouseOut={(e) => e.currentTarget.style.transform = "scale(1.0)"}
                                            />
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {tenNintyCompliance.map((item) => (
                                        <tr key={item.id}>
                                            <td>{item.id}</td>
                                            <td style={{ fontWeight: 600, color: "#0f172a" }}>{item.name}&nbsp;{item.lastName}</td>
                                            <td className="col-amount text-right">
                                                {"$" + formatAmount(parseFloat(item.totalInvoiceAmount) || 0)}
                                            </td>
                                            <td className="col-amount text-right">
                                                {"$" + formatAmount(parseFloat(item.totalPaidAmount) || 0)}
                                            </td>
                                            <td
                                                className="col-amount text-right"
                                                style={{
                                                    color: (parseFloat(item.totalDueAmount) || 0) > 0 ? "#ef4444" : "#10b981",
                                                    fontWeight: 700
                                                }}
                                            >
                                                {"$" + formatAmount(parseFloat(item.totalDueAmount) || 0)}
                                            </td>
                                            <td>
                                                {item.complianceDocs.length > 0 ? (
                                                    <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                                                        {item.complianceDocs.map((doc) => (
                                                            <button
                                                                key={doc.name}
                                                                className="btn btn-sm btn-link pl-0 text-left font-weight-bold"
                                                                style={{ color: "#4f46e5", padding: 0, fontSize: "12.5px" }}
                                                                onClick={() => handleDownloadFile(doc)}
                                                            >
                                                                <i className="fa fa-download" style={{ marginRight: "6px" }}></i>
                                                                {doc.name}
                                                            </button>
                                                        ))}
                                                        <div style={{ fontSize: "11px", color: "#64748b", marginTop: "2px" }}>
                                                            <i className="fa fa-calendar-o" style={{ marginRight: "4px" }}></i>
                                                            <Moment format="MMM Do, YYYY h:mm a">
                                                                {item.addedDateTime}
                                                            </Moment>
                                                        </div>
                                                        {item.notes && (
                                                            <div style={{
                                                                fontSize: "11.5px",
                                                                color: "#475569",
                                                                background: "#f1f5f9",
                                                                padding: "4px 8px",
                                                                borderRadius: "4px",
                                                                marginTop: "4px",
                                                                whiteSpace: "normal"
                                                            }}>
                                                                {item.notes}
                                                            </div>
                                                        )}
                                                    </div>
                                                ) : (
                                                    <button
                                                        className="ach-pay-btn"
                                                        style={{ fontSize: "11.5px", height: "30px", padding: "0 10px" }}
                                                        onClick={() => handleShowHideCompliance("", item)}
                                                    >
                                                        <i className="fa fa-upload" style={{ marginRight: "6px" }}></i>
                                                        Upload 1099 Statement
                                                    </button>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ) : (
                            <div className="wf-empty-state">
                                <div className="wf-empty-icon">
                                    <i className="fa fa-search"></i>
                                </div>
                                <p className="wf-empty-title">No Matching Records</p>
                                <p className="wf-empty-desc">No 1099 candidate records matched your search query. Try adjusting your search term.</p>
                            </div>
                        )}
                    </div>

                    {/* Pagination */}
                    {filteredReports.length > 0 && (
                        <div style={{ marginTop: "16px" }}>
                            <Pagination
                                currentPage={currentPage}
                                pageSize={pageSize}
                                itemsCount={filteredReports.length}
                                onPageChange={handlePageChange}
                                startIndex={startIndex}
                                endIndex={endIndex}
                            />
                        </div>
                    )}
                </div>
            )}

            <AddComplaince
                showHideCompliance={showHideCompliance}
                handleShowHideCompliance={handleShowHideCompliance}
                type="1099"
                selectedObj={selectedObj}
            />

            <WorkflowMapPopup
                workflowShowHide={workflowShowHide}
                handleWorkflowModalShowHide={handleWorkflowModalShowHide}
                selectedObj={{ ciid: 467, currentTask: "Compliance" }}
            />
        </div>
    );
};

export default Ten99CandidateComp;